import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './Component/Navbar';
import About from './pages/About';
import Contact from './pages/Contact';
import HelpDesk from './pages/HelpDesk';
import Home from './pages/Home';
import Prices from './pages/Prices';
import Service from './pages/Service';

function App() {
  return (
    <Router>
      <Navbar />
      <div className="pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/prices" element={<Prices />} />
          <Route path="/helpdesk" element={<HelpDesk />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
